/* import __COLOCATED_TEMPLATE__ from './upfront-collection-users.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();